/*##### Start Our Custom Script #####*/
/* ========== Product Detail Page ========== */
function PDP_product_sticky_bar(){
    var pdpLocation = $(location).attr('href');
    var pdpGalleryHeight = $(".product-gallery").height();
    var scroll = $(window).scrollTop();
    if (top.location.pathname === pdpLocation){
    }else {
      if ($(window).width() <= 999){
        $('.product-sticky-bar').addClass('is-visible-custom') 
      }
    }
  }
  window.onresize = function() {
    PDP_product_sticky_bar();
  }
  
  $(document).ready(function() {
    var scroll = $(window).scrollTop();
    /* ========== Scroll window ========== */
    $(window).scroll(function(event) {  
      if ($(window).scrollTop() >= 1) {
        $('body').addClass('headerFixed');
        $('.site_header').addClass('fixedHeader');
        $('.shopify-section--slideshow-front-page').addClass('hideHomeBanner');
      } else {
        $('body').removeClass('headerFixed');
        $('.site_header').removeClass('fixedHeader');
        $('.shopify-section--slideshow-front-page').removeClass('hideHomeBanner');
      }
    }).scroll();
    /* ========== Scroll window ========== */
  
    /* ========== Circle Animate Text ========== */
    $.fn.lettering = function(name) {
        $(".range-tagline-list li").each( function () {
            var range_list = $(this).attr("aria-controls");
            var range_no = $(this).attr("aria-details");
            var range_listValue = $(this).text().split('');
            $('.range-tagline-list li').each(function() {
                if (range_list === this.id) {
                    for(var i = 0; i < range_listValue.length; i++){
                        $(this).append(`<span class="${name}-${i}" style="transform:rotate(${i * 13.25}deg)">${range_listValue[i]}</span>`);
                    }
                }
            });
        });
    }
    $.fn.rotate = function(children) {
        this.css({
            transform: 'rotate(-' + parseInt((360 / 0) * ((children.text().length - 1) / 2)) + 'deg)'
        });
    };
    var parent = $('.range-tagline-list');
    var children = parent.children('.range-tagline-list li');
    parent.rotate(children);
    children.lettering('char');
    /* ========== Circle Animate Text ========== */
    /* ========== Disable Default AutoComplete ========== */
    $('input').attr('autocomplete', 'off');   
  });
  
  /* ========== Product Subscription (Counter)  ========== */
  var counted = 0;
  $(window).scroll(function() {
      if($(".best-seller-counter").length) {
          var oTop = $('.best-seller-counter').offset().top - window.innerHeight;
          if (counted == 0 && $(window).scrollTop() > oTop) {
              $('.myCount').each(function () {
                  $(this).prop('Counter',0).animate({
                      Counter: $(this).text()
                  }, {
                      duration: 4000,
                      easing: 'swing',
                      step: function (now) {
                          $(this).text(Math.ceil(now).toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1"));
                      }
                  });
              });
              counted = 1;
          }
      }
  });
  
  /*##### Winter Snow Script Start #####*/
  
  // var requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;
  // var transforms = ["transform", "msTransform", "webkitTransform", "mozTransform", "oTransform"];
  // var transformProperty = getSupportedPropertyName(transforms);
  // // Array to store our Snowflake objects
  // var snowflakes = [];
  // // Global variables to store our browser's window size
  // var browserWidth;
  // var browserHeight;
  // // Specify the number of snowflakes you want visible
  // var numberOfSnowflakes = 15;
  // // Flag to reset the position of the snowflakes
  // var resetPosition = false;
  // // It all starts here
  // function setup() {
  //   window.addEventListener("DOMContentLoaded", generateSnowflakes, false);
  //   window.addEventListener("resize", setResetFlag, false);
  // }
  // setup();
  // // Vendor prefix management
  // function getSupportedPropertyName(properties) {
  //   for (var i = 0; i < properties.length; i++) {
  //     if (typeof document.body.style[properties[i]] != "undefined") {
  //       return properties[i];
  //     }
  //   }
  //   return null;
  // }
  // // Constructor for our Snowflake object
  // function Snowflake(element, speed, xPos, yPos) {
  //   // set initial snowflake properties
  //   this.element = element;
  //   this.speed = speed;
  //   this.xPos = xPos;
  //   this.yPos = yPos;
  //   // declare variables used for snowflake's motion
  //   this.counter = 0;
  //   this.sign = Math.random() < 0.5 ? 1 : -1;
  //   // setting an initial opacity and size for our snowflake
  //   this.element.style.opacity = 0.1 + Math.random();
  //   this.element.style.fontSize = 9 + Math.random() * 9 + "px";
  // }
  // // The function responsible for actually moving our snowflake
  // Snowflake.prototype.update = function () {
  //   // using some trigonometry to determine our x and y position
  //   this.counter += this.speed / 4500;
  //   this.xPos += (this.sign * this.speed * Math.cos(this.counter)) / 30;
  //   this.yPos += Math.sin(this.counter) / 30 + this.speed / 45;
  //   // setting our snowflake's position
  //   setTranslate3DTransform(
  //     this.element,
  //     Math.round(this.xPos),
  //     Math.round(this.yPos)
  //   );
  //   // if snowflake goes below the browser window, move it back to the top
  //   if (this.yPos > browserHeight) {
  //     this.yPos = -25;
  //   }
  // };
  // // A performant way to set your snowflake's position
  // function setTranslate3DTransform(element, xPosition, yPosition) {
  //   var val = "translate3d(" + xPosition + "px, " + yPosition + "px" + ", 0)";
  //   element.style[transformProperty] = val;
  // }
  // // The function responsible for creating the snowflake
  // function generateSnowflakes() {
  //   // get our snowflake element from the DOM and store it
  //   var originalSnowflake = document.querySelector(".snowflake");
  //   // access our snowflake element's parent container
  //   var snowflakeContainer = originalSnowflake.parentNode;
  //   // get our browser's size
  //   browserWidth = document.documentElement.clientWidth;
  //   browserHeight = document.documentElement.clientHeight;
  //   // create each individual snowflake
  //   for (var i = 0; i < numberOfSnowflakes; i++) {
  //     // clone our original snowflake and add it to snowflakeContainer
  //     var snowflakeClone = originalSnowflake.cloneNode(true);
  //     snowflakeContainer.appendChild(snowflakeClone);
  //     // set our snowflake's initial position and related properties
  //     var initialXPos = getPosition(50, browserWidth);
  //     var initialYPos = getPosition(50, browserHeight);
  //     var speed = 5 + Math.random() * 30;
  //     // create our Snowflake object
  //     var snowflakeObject = new Snowflake(
  //       snowflakeClone,
  //       speed,
  //       initialXPos,
  //       initialYPos
  //     );
  //     snowflakes.push(snowflakeObject);
  //   }
  //   // remove the original snowflake because we no longer need it visible
  //   snowflakeContainer.removeChild(originalSnowflake);
  //   // call the moveSnowflakes function every 30 milliseconds
  //   moveSnowflakes();
  // }
  // // Responsible for moving each snowflake by calling its update function
  // function moveSnowflakes() {
  //   for (var i = 0; i < snowflakes.length; i++) {
  //     var snowflake = snowflakes[i];
  //     snowflake.update();
  //   }
  //   // Reset the position of all the snowflakes to a new value
  //   if (resetPosition) {
  //     browserWidth = document.documentElement.clientWidth;
  //     browserHeight = document.documentElement.clientHeight;
  //     for (var i = 0; i < snowflakes.length; i++) {
  //       var snowflake = snowflakes[i];
  //       snowflake.xPos = getPosition(50, browserWidth);
  //       snowflake.yPos = getPosition(50, browserHeight);
  //     }
  //     resetPosition = false;
  //   }
  //   requestAnimationFrame(moveSnowflakes);
  // }
  // // This function returns a number between (maximum - offset) and (maximum + offset)
  // function getPosition(offset, size) {
  // return Math.round(-1 * offset + Math.random() * (size + 3 * offset));
  // }
  // // Trigger a reset of all the snowflakes' positions
  // function setResetFlag(e) { resetPosition = true; } 
  
  /*##### Winter Snow Script End #####*/
  
  //########### Start for BOGO ###########//
    //===== BOGO Time Periods End, So that it is temporarily off. =====//
    // document.addEventListener('variant:add', function(event) {
    //   let items = event.detail.items; // Get items added
    //   let cart = event.detail.cart; // The whole cart content after the update
    
    //   // console.log(items);
    //   // console.log(cart);
      
    //   let currentItem = items[0];
    //   var currentItemId = currentItem.id;
    //   var currentItemVariantId = currentItem.variant_id;
    //   var currentItemQuantity = currentItem.quantity;
    
    //   // console.log(currentItemId + ' - ' + currentItemVariantId + ' - ' + currentItemQuantity);
    
    //   let bogoVariantsArray = [44263325860059, 44472742084827, 44105884795099, 44263325597915];
    //   let searchElement = currentItemVariantId;
      
    //   if (bogoVariantsArray.includes(searchElement)) {
    //     var cartqty = ((currentItemQuantity*2)-currentItemQuantity);
    //     // console.log('Variant has ' + currentItemVariantId + ' - ' + currentItemQuantity + ' - ' + searchElement);
  
    //     let data = {
    //       "id": searchElement,
    //       "quantity": cartqty
    //     }
    
    //     $.ajax({
    //       type: 'POST',
    //       url: '/cart/add.js',
    //       data: data,
    //       dataType: 'json',
    //       success: function() { 
    //         document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
    //           bubbles: true  //this code is for prestige theme, is to refresh the cart
    //        }));
    //       }
    //     });
    //     document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
    //       bubbles: true    // same code for prestige theme   
    //     }));
  
    //   } else {
    //     // console.log('Variant has not ' + currentItemVariantId + ' - ' + currentItemQuantity + ' - ' + searchElement);
    //   }
    // });
  
    // document.addEventListener('variant:change', function(event) {
    //   let variant = event.detail.variant; // Gives you access to the whole variant details
    //   let previousVariant = event.detail.previousVariant; // Gives you access to the details of the previously selected variant
    //   let product = event.detail.product; // Gives you access to the whole product that the variant belongs to
    //   let form = event.target; // The form that triggers the change
  
    //   // console.log('variant => ', variant);
  
    //   var variantID = variant.id;
  
    //   var SpecificVariantClass = "special-sticker-"+variantID+"-BOGO";
    //   // console.log('specialStickerContent => ', SpecificVariantClass);
  
    //   let specialStickerWrapper = document.querySelector("#special-stickers-wrapper");
    //   // console.log('specialStickerWrapper => ', specialStickerWrapper);
  
    //   let specialStickerContent = specialStickerWrapper.querySelectorAll("#special-stickers-wrapper sticker");
    //   // console.log('specialStickerContent => ', specialStickerContent);
  
    //   specialStickerContent.forEach((stickerItem) => {
    //     if ( stickerItem.classList.contains( SpecificVariantClass ) ) {
    //       stickerItem.style.display = 'block';
    //       // console.log('Yes');
    //     } else {
    //       stickerItem.style.display = 'none';
    //       // console.log('No');
    //     }
    //   });
  
    //   var hideBestSellerSVG = false;
    //   specialStickerContent.forEach((stickerItem) => {
    //     if ( stickerItem.classList.contains( SpecificVariantClass ) ) {
    //       hideBestSellerSVG = true;
    //       return;
    //       // console.log('Yes');
    //     }
    //   });
  
    //   let bestSellerSVGContainer = document.querySelector(".product-gallery>svg");
    //   if(hideBestSellerSVG == true  ) {
    //       bestSellerSVGContainer.style.display = 'none';
    //       // console.log('Yes');
    //   } else {
    //       bestSellerSVGContainer.style.display = 'block';
    //       // console.log('No');
    //   }
    // });
  //########### End for BOGO ###########//
  /* Extra Discount Badge */
let getValperML = document.getElementsByClassName('perML_val');
let printDiscountVal = document.getElementsByClassName('discountVal');
const discountBadgeCommonLabel = "Extra";
const discountBadgeCommonLabelOff = "Off";
let getValperML_Parent;
let getValperML_Sibling_span_val;
let getValperML_Sibling_span_val_before;
let getValperML_Sibling_price_val;
let productVarientEmptyArray = [];
let productVarientSortedValues;
let val1000ML;
//let removeDot0For1000ML; 
let first2Num1000ML;
let val1800ML;
let first2Num1800ML;
let parent_Variant_PricePerML;

// Function for remove before dot(.) value
function getDecimalPart(num) {
  if (Number.isInteger(num)) { return 0 }
  const decimalStr = num.toString().split('.')[1];
  return decimalStr;
  //return Number(decimalStr);
}
// End Function for remove before dot(.) value
// Loop for per ML price
for (var iVal = 0; iVal < getValperML.length; iVal++) {
  getValperML_Parent = getValperML[iVal].parentNode;
  getValperML_Sibling_span_val = getValperML_Parent.childNodes[0].textContent;
  getValperML_Sibling_span_val_before = getValperML_Sibling_span_val.substring(0, getValperML_Sibling_span_val.indexOf(' '));
  getValperML_Sibling_price_val = getValperML_Parent.childNodes[2].textContent;
  let getNumberFromGetValperML_Sibling_price_val = getValperML_Sibling_price_val.match(/[\d,]+\.\d+/)[0];
}
// Loop for compare discount value
for (let iVal = 0; iVal < printDiscountVal.length; iVal++) {
  let parent_Variant_Size = printDiscountVal[iVal].parentElement.childNodes[0].textContent;
  parent_Variant_PricePerML = printDiscountVal[iVal].parentElement.childNodes[2].textContent;
  let removeDotFrom_PricePerML = String(parent_Variant_PricePerML).match(/[\d,]+\.\d+/)[0];
  let firstTwoNumFrom_PricePerML = String(getDecimalPart(removeDotFrom_PricePerML)).slice(0, 2);
  // Get Only Number From String
  function extractNumbersFromString(parent_Variant_Size) {
    // Use regular expression to match digits
    const numbersArray = parent_Variant_Size.match(/\d+/g);
    // Convert the array of matched digits to a string
    const numbersString = numbersArray ? numbersArray.join('') : '';
    // Convert the string to a number
    const numbers = parseInt(numbersString, 10);
    return numbers;
  }
  // Push price value into empty array
  productVarientEmptyArray.push(firstTwoNumFrom_PricePerML);
  // Sort old array value to new array
  productVarientSortedValues = productVarientEmptyArray.toSorted((a, b) => a - b);
  // Extract Numbers of size 
  const extractedNumbers_parent_Variant_Size = extractNumbersFromString(parent_Variant_Size);
  // Use Timeout function for get/print last/currect value
  setTimeout(() => {
    if (printDiscountVal.length == 3) {
      //console.log('sort value : ', productVarientSortedValues);
      // For 1000 ML
      val1000ML = (productVarientSortedValues[2] - productVarientSortedValues[1]) / productVarientSortedValues[2];
      first2Num1000ML = String(getDecimalPart(val1000ML)).slice(0, 2);
      // If Number have only one digit then add "0"
      if (first2Num1000ML.length == 1) {
        first2Num1000ML = `${first2Num1000ML + "0"}`
      }
      // For 1800 ML
      val1800ML = (productVarientSortedValues[2] - productVarientSortedValues[0]) / productVarientSortedValues[2];
      first2Num1800ML = String(getDecimalPart(val1800ML)).slice(0, 2);
      // If Number have only one digit then add "0"
      if (first2Num1800ML.length == 1) {
        first2Num1800ML = `${first2Num1800ML + "0"}`
      }
      // Inside Condition
      if (extractedNumbers_parent_Variant_Size == 1000 || extractedNumbers_parent_Variant_Size == 1 && first2Num1000ML !== 'Na') {
        printDiscountVal[iVal].textContent = `${discountBadgeCommonLabel} ${first2Num1000ML}${'% ' + discountBadgeCommonLabelOff}`;
      } else if (extractedNumbers_parent_Variant_Size == 1800 || extractedNumbers_parent_Variant_Size == 1.8 && first2Num1800ML !== 'Na') {
        printDiscountVal[iVal].textContent = `${discountBadgeCommonLabel} ${first2Num1800ML}${'% ' + discountBadgeCommonLabelOff}`;
      } else {
        printDiscountVal[iVal].textContent = '';
      }
    } else if (printDiscountVal.length == 2) {
      //console.log('sort value : ', productVarientSortedValues);
      // For 1800 ML
      val1800ML = (productVarientSortedValues[1] - productVarientSortedValues[0]) / productVarientSortedValues[1];
      first2Num1800ML = String(getDecimalPart(val1800ML)).slice(0, 2);
      // If Number have only one digit then add "0"
      if (first2Num1800ML.length == 1) {
        first2Num1800ML = `${first2Num1800ML + "0"}`
      }
      // Inside Condition
      if (extractedNumbers_parent_Variant_Size == 1000 || extractedNumbers_parent_Variant_Size == 1) {
        printDiscountVal[iVal].textContent = '';
      } else if (extractedNumbers_parent_Variant_Size == 1800 || extractedNumbers_parent_Variant_Size == 1.8 && first2Num1800ML !== 'Na') {
        printDiscountVal[iVal].textContent = `${discountBadgeCommonLabel} ${first2Num1800ML}${'% ' + discountBadgeCommonLabelOff}`;
      } else {
        printDiscountVal[iVal].textContent = '';
      }
    } else {
      printDiscountVal[iVal].textContent = '';
    }
  }, 1000);
}
// End Loop for compare discount value
/* End Extra Discount Badge */


/*** === Check If Bundle Products Exists On A Page Or Not === ***/
let pdpMoreOfferWrapper = document.getElementsByClassName("product-offers__list product-offers__list--custom-carousel")[0];
if (document.querySelector('div[data-block-type="bundleproduct"]')) {} else {
  let selectAnchorBundleLink = document.querySelector('a[href="#bundleProductsSec"]');
  //selectAnchorBundleLink.classList.add("hide-link");
  //selectParentEleAnchorBundle.classList.add("hide-offer-block");
  if(selectAnchorBundleLink){
    let selectParentEleAnchorBundle = selectAnchorBundleLink.closest('.product-offers__item');
    selectParentEleAnchorBundle.remove();
  }
}
if(pdpMoreOfferWrapper){
  let offerChildItemsCount = pdpMoreOfferWrapper.childElementCount;
  pdpMoreOfferWrapper.classList.add(`offersItems-${offerChildItemsCount}`); 
}
/*** === Check If Bundle Products Exists On A Page Or Not === ***/